// src/pages/NotFound.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh', 
      p: 3 
    }}>
      <Typography variant="h1">404</Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>Az oldal nem található</Typography>
      <Button 
        component={Link} 
        to="/" 
        variant="contained" 
        color="primary"
      >
        Vissza a főoldalra
      </Button>
    </Box>
  );
};

export default NotFound;